<a
    *appHasPermissionId="permissionList.service; else justNameTemplateRef"
    [routerLink]="['', 'service', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
